module.exports = "/_next/static/images/180486719be2a57343196dc538c351bc-computer-desk-man@md-1x.jpg.webp";